// export { default as ChangePasswordSuccess } from './change-password-success';
// export { default as NewUserChangePassword } from './new-user-change-password';
// export { default as ChangePasswordSettings } from './change-password-settings';
// export { default } from './change-password';
import ChangePasswordSuccess from './change-password-success';
import ChangePasswordSettings from './change-password-settings';
import NewUserChangePassword from './new-user-change-password';
import ChangePassword from './change-password';   // change password without airlock

export default {
    ChangePasswordSuccess,
    ChangePasswordSettings,
    NewUserChangePassword,
    ChangePassword
}